import authService from 'services/authService';
import dataService from 'services/dataService';
import helper from './actionHelper';

export const getAccountDetails = userId => {
  return helper.dispatchAsyncAction(async () => {
    let accountDetails = await dataService.getAccountDetails(userId);

    //TODO move to reducer
    let userKeys = accountDetails?.api_keys?.filter(key => key.user_id === userId);

    if (userKeys) {
      let firstKey = userKeys[0];

      if (firstKey) authService.saveApiToken(firstKey.id || '');
    }

    return accountDetails;
  }, null);
};

export const loadPlans = () => {
  return helper.dispatchAsyncAction(async () => {
    let plans = await dataService.getPlans();
    return plans;
  }, null);
};


export const loadItineraries = () => {
  return helper.dispatchAsyncAction(async () => {
    let itineraries = await dataService.getItineraries();
    return itineraries;
  }, null);
};


export const deleteItinerary = id => {
  return helper.dispatchAsyncAction(async () => {
    let itineraries = await dataService.deleteItinerary(id);
    return itineraries;
  }, null);
};
